(function () {
  'use strict';

  var config = window.PAWS_ANALYTICS_CONFIG || {};
  var currency = config.currency || 'EUR';
  var hasViewedItem = false;

  function centsToAmount(value) {
    var number = Number(value || 0);
    if (!Number.isFinite(number)) return 0;
    return Math.round(number) === number && number > 99 ? number / 100 : number;
  }

  function normalizeItem(item) {
    if (!item) return null;

    var quantity = Number(item.quantity || 1);
    var price = centsToAmount(item.price || item.final_price || item.discounted_price || 0);

    return {
      item_id: String(item.item_id || item.variant_id || item.id || ''),
      item_name: item.item_name || item.product_title || item.title || '',
      item_brand: item.item_brand || item.vendor || 'PAWSGRIP',
      item_category: item.item_category || item.product_type || '',
      item_variant: item.item_variant || item.variant_title || '',
      price: price,
      quantity: Number.isFinite(quantity) && quantity > 0 ? quantity : 1,
    };
  }

  function pushDataLayer(eventName, ecommerce) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({
      event: eventName,
      ecommerce: ecommerce || {},
    });
  }

  function sendGtag(eventName, ecommerce) {
    if (typeof window.gtag !== 'function') return;
    window.gtag('event', eventName, ecommerce || {});
  }

  function trackEcommerce(eventName, ecommerce) {
    pushDataLayer(eventName, ecommerce);
    sendGtag(eventName, ecommerce);
  }

  function trackSimple(eventName, params) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: eventName }, params || {}));
    sendGtag(eventName, params || {});
  }

  function trackViewItem() {
    if (hasViewedItem || !config.product) return;
    var item = normalizeItem(config.product);
    if (!item || !item.item_id) return;
    hasViewedItem = true;

    trackEcommerce('view_item', {
      currency: currency,
      value: item.price,
      items: [item],
    });
  }

  function trackAddToCart(response, formData) {
    var item = normalizeItem(response);
    if (!item || !item.item_id) {
      item = normalizeItem(config.product);
    }
    if (!item || !item.item_id) return;

    var formQuantity = formData && Number(formData.get('quantity'));
    if (Number.isFinite(formQuantity) && formQuantity > 0) {
      item.quantity = formQuantity;
    }

    trackEcommerce('add_to_cart', {
      currency: currency,
      value: Number((item.price * item.quantity).toFixed(2)),
      items: [item],
    });
  }

  function bindCheckoutIntent() {
    document.addEventListener('click', function (event) {
      var link = event.target.closest('a[href]');
      if (!link) return;
      var href = link.getAttribute('href') || '';

      if (href.indexOf('/checkout') !== -1 || href.indexOf('checkout.shopify.com') !== -1) {
        trackEcommerce('begin_checkout', {
          currency: currency,
          checkout_location: 'theme_link',
        });
      }
    });

    document.addEventListener('submit', function (event) {
      var form = event.target;
      if (!form || !form.action) return;
      var submitter = event.submitter;
      var submitterName = submitter ? (submitter.getAttribute('name') || '').toLowerCase() : '';
      var submitterText = submitter ? (submitter.textContent || '').trim().toLowerCase() : '';
      var isCheckoutForm = form.action.indexOf('/checkout') !== -1;
      var isCartCheckout = form.action.indexOf('/cart') !== -1 && (
        submitterName === 'checkout' ||
        submitterText.indexOf('checkout') !== -1 ||
        submitterText.indexOf('finalizar compra') !== -1 ||
        submitterText.indexOf('pagar') !== -1
      );

      if (isCheckoutForm || isCartCheckout) {
        trackEcommerce('begin_checkout', {
          currency: currency,
          checkout_location: 'theme_form',
        });
      }
    });
  }

  function bindBusinessEvents() {
    document.addEventListener('click', function (event) {
      var link = event.target.closest('a[href], button');
      if (!link) return;
      var href = link.getAttribute('href') || '';
      var text = (link.textContent || '').trim().toLowerCase();

      if (href.indexOf('/collections/kit-guerrera') !== -1) {
        trackSimple('select_promotion', {
          promotion_name: 'Kit Guerrera PAWSGRIP',
          creative_name: 'theme_cta',
          location_id: config.page_type || 'site',
        });
      }

      if (href.indexOf('guia') !== -1 || text.indexOf('guia') !== -1 || text.indexOf('talla') !== -1) {
        trackSimple('generate_lead', {
          lead_type: 'size_or_care_guide',
          location_id: config.page_type || 'site',
        });
      }

      if (href.indexOf('wa.me') !== -1 || href.indexOf('/pages/contact') !== -1 || href.indexOf('/pages/contacto') !== -1) {
        trackSimple('contact', {
          contact_type: href.indexOf('wa.me') !== -1 ? 'whatsapp' : 'contact_page',
          location_id: config.page_type || 'site',
        });
      }
    });

    document.addEventListener('submit', function (event) {
      var form = event.target;
      if (!form) return;
      var emailField = form.querySelector('input[type="email"]');
      if (emailField) {
        trackSimple('sign_up', {
          method: 'email',
          location_id: config.page_type || 'site',
        });
      }
    });
  }

  window.PawsAnalytics = {
    trackAddToCart: trackAddToCart,
    trackEcommerce: trackEcommerce,
    trackSimple: trackSimple,
  };

  document.addEventListener('DOMContentLoaded', function () {
    trackViewItem();
    bindCheckoutIntent();
    bindBusinessEvents();
  });
})();
